import React from 'react';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import Loader from '../Loader';

export default branch(
  ({ data }) => data && data.loading,
  renderComponent(({ loader }) => <Loader {...loader} active />),
);
